import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export default function useDeveloperFeatureFlags() {
  const [developerFeatureFlags, setDeveloperFeatureFlags] = useState({});

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, "platformSettings", "developerControls"),
      (snap) => {
        setDeveloperFeatureFlags(snap.exists() ? (snap.data()?.featureFlags || {}) : {});
      },
      (err) => {
        console.warn("[useDeveloperFeatureFlags] Failed to load developer controls:", err);
        setDeveloperFeatureFlags({});
      }
    );

    return () => unsub();
  }, []);

  return developerFeatureFlags;
}
